// extracted by mini-css-extract-plugin
export default {"wrapper":"PzCrn5z5fsCDVcmpM7wr","container":"fwz6BUjAUM4m0wOhVyeO","header":"mupf5ojsp6odq0WqmH47","content":"tENELf0vHy7MIbwd6hrr"};